module.exports = __webpack_public_path__ + "img/t-b.297ec92e.png";